import React from "react";

function EmpresaCierre() {
    return (
        <section className="empresa-cierre">
      <span className="empresa-eyebrow">
        V++ / NUESTRA VISIÓN
      </span>

            <h2>
                No solo imaginamos el futuro.
                <br />
                <span>Lo diseñamos, lo programamos</span>
                <br />
                y lo ponemos en marcha.
            </h2>

            <p>
                Todos los días, con talento, innovación y compromiso.
            </p>
        </section>
    );
}

export default EmpresaCierre;
